<footer class="footer-distributed bg-black p-4 text-primary">
  <div class="row">
    <div class="col-md-4 col-sm-12 text-center">
      <img src="logo.svg" alt="Logo" height="50" class="cursor-poiner" />

      <ol class="py-4 d-flex justify-content-center">
        <li>
          <a
            href="https://www.facebook.com/profile.php?id=61588939880032"
            target="_blank"
            rel="noopener noreferrer"
            ><i class="bi bi-facebook fs-3"></i
          ></a>
        </li>

        <li>
          <a href="https://www.instagram.com/bazar.syria/" target="_blank" rel="noopener noreferrer"
            ><i class="bi bi-instagram fs-3"></i
          ></a>
        </li>
        <!-- <li>
          <a href="#"><i class="bi bi-tiktok fs-3"></i></a>
        </li> -->
      </ol>
      <span> {{ 'FOOTER' | translate }} </span>
    </div>
    <div class="col-md-4 col-sm-12 text-center">
      <ul class="list-unstyled px-0">
        <li>
          <strong class="cursor-poiner"
            ><i class="bi bi-envelope text-light"></i>
            <a href="mailto:support@company.com"> info&#64;bazar-s.com</a>
          </strong>
        </li>
        <li class="pt-2">
          <strong class="cursor-poiner" (click)="openWhatsApp('41762768797')"
            ><i class="bi bi-whatsapp text-success"></i>
            <span class="phone-number-text"> +41762768797</span>
          </strong>
        </li>
      </ul>
    </div>
    <div class="col-md-4 col-sm-12 text-center">
      <ul class="list-unstyled px-0">
        <li class="pb-1">
          <span class="link-primary cursor-poiner" routerLink="/data-protection">{{
            'DATA_PROTECTION' | translate
          }}</span>
        </li>
        <li class="pb-1">
          <span class="link-primary cursor-poiner" routerLink="/terms">{{
            'TERMS' | translate
          }}</span>
        </li>
        <li class="pb-1">
          <span class="link-primary cursor-poiner" routerLink="/privacy-settings">{{
            'PRIVACY_SETTINGS' | translate
          }}</span>
        </li>
        <li class="pb-1">
          <span class="link-primary cursor-poiner" routerLink="/account-deletion">{{
            'DELETE_ACCOUNT' | translate
          }}</span>
        </li>
      </ul>
    </div>
  </div>
</footer>
